/**
 * Propósito de la negociación (para qué se destina la inversión inmobiliaria).
 * Valores de DOMINIO legibles (ADR D003): internamente era texto libre
 * (businessRelationship); el portal lo acota a un catálogo corto + "Otro".
 */
export const NegotiationPurpose = {
  FAMILY_HOME: 'FAMILY_HOME',
  LONG_TERM_INVESTMENT: 'LONG_TERM_INVESTMENT',
  FAMILY_EQUITY: 'FAMILY_EQUITY',
  OTHER: 'OTHER'
} as const

export type NegotiationPurpose = (typeof NegotiationPurpose)[keyof typeof NegotiationPurpose]

export const NegotiationPurposeLabel = {
  [NegotiationPurpose.FAMILY_HOME]: 'Vivienda familiar',
  [NegotiationPurpose.LONG_TERM_INVESTMENT]: 'Inversión a largo plazo',
  [NegotiationPurpose.FAMILY_EQUITY]: 'Patrimonio familiar',
  [NegotiationPurpose.OTHER]: 'Otro propósito'
} as const satisfies Record<NegotiationPurpose, string>
